import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pass",
  "use": "icon-pass-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pass\">\r\n<circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#23BF71\" />\r\n<path d=\"M12.7 6.72292C13.1 6.32878 13.1 5.68975 12.7 5.29561C12.3001 4.90146 11.6516 4.90146 11.2517 5.29561L6.92102 9.56333L4.74832 7.42221C4.34837 7.02807 3.69992 7.02807 3.29996 7.42221C2.90001 7.81635 2.90001 8.45538 3.29996 8.84952L6.18506 11.6927C6.18892 11.6966 6.19281 11.7005 6.19675 11.7044C6.5967 12.0985 7.24515 12.0985 7.64511 11.7044L12.7 6.72292Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pass.svg
// module id = UbXU
// module chunks = 14